import GoogleDrive from '@uppy/google-drive';
import Dropbox from '@uppy/dropbox';
import Facebook from '@uppy/facebook';
import Instagram from '@uppy/instagram';
import Audio from '@uppy/audio';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import CompanionConfig from './CompanionConfig';
import FileTypesConfig from './FileTypesConfig';
import { uniq } from '../../utils/helpers';
import GooglePicker from '../../plugins/GooglePicker/GooglePicker';

// ProviderConfig returns uppy plugins and their configuration based on passed props

const sourceMap = {
  GooglePicker: () => 'GooglePicker',
  // TODO: Remove GoogleDrive as a config here once we've fully switched over to GooglePicker
  GoogleDrive: () => 'GoogleDrive',
  Dropbox: () => 'Dropbox',
  Facebook: () => 'Facebook',
  Instagram: () => 'Instagram',
  Url: () => 'Url',
  Video: (opts) => {
    if (opts.fileTypesConfig.filetypes.includes('video')) {
      opts.modes.push('video-audio');
      return 'Webcam';
    }
    return null;
  },
  Audio: (opts) => {
    if (opts.fileTypesConfig.filetypes.includes('audio')) {
      return 'Audio';
    }
    return null;
  },
  Webcam: (opts) => {
    if (opts.fileTypesConfig.filetypes.includes('image')) {
      opts.modes.push('picture');
      return 'Webcam';
    }
    return null;
  }
};

function WebcamConfig(modes) {
  return {
    countdown: false,
    modes,
    mirror: true,
    videoConstraints: {
      facingMode: 'user',
      width: { min: 720, ideal: 1280, max: 1920 },
      height: { min: 480, ideal: 800, max: 1080 },
    },
    showRecordingLength: false,
    preferredVideoMimeType: null,
    preferredImageMimeType: null,
    locale: {},
  };
}

function GooglePickerConfig(opts) {
  return {
    ...opts.companionConfig,
    multiple: opts.multiple,
    fileTypesConfig: opts.fileTypesConfig,
    loggerConfig: {
      datadogClientToken: opts.datadogClientToken,
      context: opts.loggerContext,
      enableConsole: opts.debug,
    },
  };
}

const sourceConfigMap = {
  GooglePicker: (opts) => [GooglePicker, GooglePickerConfig(opts)],
  // TODO: Remove GoogleDrive as a config here once we've fully switched over to GooglePicker
  GoogleDrive: (opts) => [GoogleDrive, opts.companionConfig],
  Dropbox: (opts) => [Dropbox, opts.companionConfig],
  Facebook: (opts) => [Facebook, opts.companionConfig],
  Instagram: (opts) => [Instagram, opts.companionConfig],
  Url: (opts) => [Url, opts.companionConfig],
  Webcam: (opts) => [Webcam, WebcamConfig(opts.modes)],
  Audio: () => [Audio, {}]
};

const ProviderConfig = (props = {}) => {
  const rawSources = props.sources;
  let sources = [];
  let sourcesConfig = [];

  if (rawSources?.length) {
    const opts = {
      companionConfig: CompanionConfig(props),
      modes: [],
      fileTypesConfig: FileTypesConfig(props),
      multiple: props.multiple,
    };
    sources = uniq(rawSources.map((s) => sourceMap[s](opts))).filter((item) => item);
    sourcesConfig = sources.map((s) => sourceConfigMap[s](opts));
  }

  return {
    pluginsProp: sources,
    plugins: sourcesConfig
  };
};

export default ProviderConfig;
